import React from 'react';

import { useApplicationContext } from '../../../../../../../shared/utils/applicationContext';
import { CommercialPriceLines } from '../../../../components/Commercial/CommercialPriceLines';
import { useOfferContext } from '../../../../context';
import { getCommercialPriceMain } from '../../../../utils/computedProps/commercial/getCommercialPriceMain';
import { getCommercialPriceSub } from '../../../../utils/computedProps/commercial/getCommercialPriceSub';

export function CommercialPriceContainer() {
  const { offer } = useOfferContext();
  const { config } = useApplicationContext();
  const isNewTaxDisplayEnabled = Boolean(config.get<boolean>('NEW_TAX_DISPLAY_ENABLED'));

  const priceMain = getCommercialPriceMain(offer);
  const priceSub = getCommercialPriceSub(offer, isNewTaxDisplayEnabled);

  return <CommercialPriceLines priceMain={priceMain} priceSub={priceSub} />;
}

CommercialPriceContainer.displayName = 'CommercialPriceContainer';
